import Dexie, { Table } from 'dexie';

export interface Project {
  id?: string | number;
  projectDetails: {
    projectName: string;
    projectDescription: string;
  };
  shippingModes: any[];
  palletConfig?: any;
  lpnData?: any;
  preShipData?: any;
  shipTestData?: any;
  postShipData?: any;
  postStackData?: any;
  stackTestData?: any;
  summaryData?: any;
  synopsisData?: any;
  imagesData?: any;
  users?: any[];
  target?: number;
  plusByUser?: boolean;
  percentage?: number;
  createdAt?: string;
  updatedAt?: string;
  palletTypes?: PalletType[];
}

export interface PalletType {
  id: number | string;
  variant: string;
  name: string;
  numberOfPallets: number | string;
  shippingModes: number[];
  lpnNumbers?: LpnNumber[];
  updatedAt?: string;
  createdAt?: string;
  projectId: number;
}

export interface LpnNumber {
  lpnNo: string;
  endStatusPallet: string;
  rqlState: string;
}

export class ProjectDatabase extends Dexie {
  projects!: Table<Project>;

  constructor() {
    super('projectDatabase');
    this.version(1).stores({
      projects: '++id, projectName'
    });
  }

  async getFullProject(projectId: string): Promise<Project | undefined> {
    return await this.projects.get(projectId);
  }
}

export const db = new ProjectDatabase(); 